"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionUtils = void 0;
const chain_1 = require("../chain");
const juneo_1 = require("../juneo");
const transaction_1 = require("../transaction");
const bytes_1 = require("./bytes");
const chain_2 = require("./chain");
const errors_1 = require("./errors");
const utxo_1 = require("./utxo");
class TransactionUtils {
    static INSTANCE;
    constructor() { }
    static getSingleton() {
        if (TransactionUtils.INSTANCE === undefined) {
            TransactionUtils.INSTANCE = new TransactionUtils();
        }
        return TransactionUtils.INSTANCE;
    }
    static async syncUtxos(provider, unsignedTx) {
        const chain = (0, chain_2.getBlockchain)(provider, unsignedTx.blockchainId);
        const api = (0, utxo_1.getUtxoAPI)(provider, chain);
        await TransactionUtils.syncInputsUtxos(unsignedTx.inputs, api);
        if (unsignedTx instanceof transaction_1.ImportTransaction) {
            const sourceChain = (0, chain_2.getBlockchain)(provider, unsignedTx.sourceChain);
            const sourceApi = (0, utxo_1.getUtxoAPI)(provider, sourceChain);
            await TransactionUtils.syncInputsUtxos(unsignedTx.importedInputs, sourceApi);
        }
    }
    static async syncInputsUtxos(inputs, api) {
        for (const input of inputs) {
            const data = (await api.getTx(input.transactionId.value)).tx;
            const tx = TransactionUtils.parseUnsignedTransaction(data);
            const output = tx.getOutput(input.utxoIndex);
            input.input.utxo = new transaction_1.Utxo(input.transactionId, input.utxoIndex, input.assetId, output);
        }
    }
    static getTypeIdName(typeId, networkId, chainId) {
        const network = juneo_1.MCNProvider.fromId(networkId);
        const chain = network.mcn.getChain(chainId);
        if (chain.vm.type === chain_1.VMType.EVM) {
            return TransactionUtils.getEVMTypeIdName(typeId);
        }
        switch (typeId) {
            case transaction_1.JVMBaseTransactionTypeId: {
                return 'JVM Base Transaction';
            }
            case transaction_1.CreateAssetTransactionTypeId: {
                return 'Create Asset Transaction';
            }
            case transaction_1.JVMImportTransactionTypeId: {
                return 'JVM Import Transaction';
            }
            case transaction_1.JVMExportTransactionTypeId: {
                return 'JVM Export Transaction';
            }
            case transaction_1.AddSupernetValidatorTransactionType: {
                return 'Add Supernet Validator Transaction';
            }
            case transaction_1.CreateChainTransactionTypeId: {
                return 'Create Chain Transaction';
            }
            case transaction_1.CreateSupernetTransactionTypeId: {
                return 'Create Supernet Transaction';
            }
            case transaction_1.PlatformImportTransactionTypeId: {
                return 'Platform Import Transaction';
            }
            case transaction_1.PlatformExportTransactionTypeId: {
                return 'Platform Export Transaction';
            }
            case transaction_1.RemoveSupernetValidatorTransactionTypeId: {
                return 'Remove Supernet Validator Transaction';
            }
            case transaction_1.TransformSupernetTransactionTypeId: {
                return 'Transform Supernet Transaction';
            }
            case transaction_1.AddPermissionlessValidatorTransactionTypeId: {
                return 'Add Permissionless Validator Transaction';
            }
            case transaction_1.AddPermissionlessDelegatorTransactionTypeId: {
                return 'Add Permissionless Delegator Transaction';
            }
            case transaction_1.TransferSupernetOwnershipTransactionTypeId: {
                return 'Transfer Supernet Ownership Transaction';
            }
            case transaction_1.PlatformBaseTransactionTypeId: {
                return 'Platform Base Transaction';
            }
            default: {
                throw new errors_1.ParsingError(`unsupported transaction type id "${typeId}"`);
            }
        }
    }
    static getEVMTypeIdName(typeId) {
        switch (typeId) {
            case transaction_1.EVMImportTransactionTypeId: {
                return 'EVM Import Transaction';
            }
            case transaction_1.EVMExportTransactionTypeId: {
                return 'EVM Export Transaction';
            }
            default: {
                throw new errors_1.ParsingError(`unsupported transaction type id "${typeId}"`);
            }
        }
    }
    static parseUnsignedTransaction(data) {
        const reader = bytes_1.JuneoBuffer.from(data).createReader();
        // skip codec reading
        reader.skip(2);
        const typeId = reader.readUInt32();
        const networkId = reader.readUInt32();
        const blockchainId = new transaction_1.BlockchainId(reader.read(transaction_1.BlockchainIdSize).toCB58());
        const network = juneo_1.MCNProvider.fromId(networkId);
        const chain = network.mcn.getChain(blockchainId.value);
        if (chain.vm.type === chain_1.VMType.EVM) {
            return TransactionUtils.parseUnsignedEVMTransaction(data, typeId);
        }
        const notImplementedTypeIdError = new Error(`type id ${typeId} parsing is not implemented yet`);
        switch (typeId) {
            case transaction_1.JVMBaseTransactionTypeId: {
                return transaction_1.JVMBaseTransaction.parse(data);
            }
            case transaction_1.CreateAssetTransactionTypeId: {
                throw notImplementedTypeIdError;
            }
            case transaction_1.JVMImportTransactionTypeId: {
                return transaction_1.JVMImportTransaction.parse(data);
            }
            case transaction_1.JVMExportTransactionTypeId: {
                return transaction_1.JVMExportTransaction.parse(data);
            }
            case transaction_1.AddSupernetValidatorTransactionType: {
                return transaction_1.AddSupernetValidatorTransaction.parse(data);
            }
            case transaction_1.CreateChainTransactionTypeId: {
                return transaction_1.CreateChainTransaction.parse(data);
            }
            case transaction_1.CreateSupernetTransactionTypeId: {
                return transaction_1.CreateSupernetTransaction.parse(data);
            }
            case transaction_1.PlatformImportTransactionTypeId: {
                return transaction_1.PlatformImportTransaction.parse(data);
            }
            case transaction_1.PlatformExportTransactionTypeId: {
                return transaction_1.PlatformExportTransaction.parse(data);
            }
            case transaction_1.RemoveSupernetValidatorTransactionTypeId: {
                return transaction_1.RemoveSupernetValidatorTransaction.parse(data);
            }
            case transaction_1.TransformSupernetTransactionTypeId: {
                throw notImplementedTypeIdError;
            }
            case transaction_1.AddPermissionlessValidatorTransactionTypeId: {
                return transaction_1.AddPermissionlessValidatorTransaction.parse(data);
            }
            case transaction_1.AddPermissionlessDelegatorTransactionTypeId: {
                return transaction_1.AddPermissionlessDelegatorTransaction.parse(data);
            }
            case transaction_1.TransferSupernetOwnershipTransactionTypeId: {
                return transaction_1.TransferSupernetOwnershipTransaction.parse(data);
            }
            case transaction_1.PlatformBaseTransactionTypeId: {
                return transaction_1.PlatformBaseTransaction.parse(data);
            }
            default: {
                throw new errors_1.ParsingError(`unsupported transaction type id "${typeId}"`);
            }
        }
    }
    static parseUnsignedEVMTransaction(data, typeId) {
        switch (typeId) {
            case transaction_1.EVMImportTransactionTypeId: {
                return transaction_1.JEVMImportTransaction.parse(data);
            }
            case transaction_1.EVMExportTransactionTypeId: {
                return transaction_1.JEVMExportTransaction.parse(data);
            }
            default: {
                throw new errors_1.ParsingError(`unsupported transaction type id "${typeId}"`);
            }
        }
    }
}
exports.TransactionUtils = TransactionUtils;
